import { render } from "./VariaveisTemplate.vue?vue&type=template&id=4da80990&scoped=true&ts=true"
import script from "./VariaveisTemplate.vue?vue&type=script&lang=ts"
export * from "./VariaveisTemplate.vue?vue&type=script&lang=ts"

import "./VariaveisTemplate.vue?vue&type=style&index=0&id=4da80990&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da80990"]])

export default __exports__